// extracted by mini-css-extract-plugin
export default {"slugInput":"LessonInput_slugInput__0K0ML","durationInput":"LessonInput_durationInput__pRp6D"};